module.exports = __webpack_public_path__ + "static/img/united-kingdom.6f382b2.png";